import React, { useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Spacer,
  Text,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import { SearchIcon } from "@chakra-ui/icons";

const ControllerSearchFilters = ({
  searchParams,
  handleInputChange,
  handleSearch,
  handleReset,
}) => {
  const styles = {
    topGrid: {
      templateColumns: "repeat(5, 1fr)",
      gap: { base: 1, lg: 6 },
      px: { base: 0, lg: 4 },
      pb: { base: 2, md: 6 },
      alignItems: "end",
    },
    colSpan1: { base: 5, sm: 5, md: 5, lg: 1 },
    colSpan2: { base: 5, sm: 5, md: 1, lg: 1 },
    colSpan3: { base: 6, sm: 6, md: 1, lg: 1 },
    colSpan4: { base: 6, sm: 6, md: 2, lg: 1 },
    headerText: {
      fontFamily: "'Barlow', sans-serif",
      fontStyle: "normal",
      letterSpacing: "0.05rem",
      fontSize: 14,
      py: "0.25rem",
    },
    searchBar: {
      borderRadius: 3,
    },
    selector: {
      size: "sm",
      borderRadius: 3,
    },
    searchButton: {
      colorScheme: "green",
      width: "66%",
      fontSize: "12px",
      // size: "sm",
      size: "sm",
      borderRadius: 3,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 600,
      fontStyle: "normal",
      letterSpacing: ".05em",
      textTransform: "uppercase",
    },
    resetButton: {
      colorScheme: "green",
      variant: "outline",
      width: "30%",
      borderRadius: 3,
      fontSize: "12px",
      size: "sm",
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 600,
      fontStyle: "normal",
      letterSpacing: ".05em",
      textTransform: "uppercase",
    },
  };

  useEffect(() => {
    handleSearch();
  }, [searchParams]);

  return (
    <Grid {...styles.topGrid}>
      <GridItem colSpan={{ base: 5, sm: 5, md: 5, lg: 1 }}>
        <Box>
          <Text {...styles.headerText}>What are you looking for?</Text>
          <InputGroup size={"sm"}>
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.300" />
            </InputLeftElement>
            <Input
              {...styles.searchBar}
              type="text"
              placeholder="Search by Location"
              value={searchParams.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
            />
          </InputGroup>
        </Box>
      </GridItem>
      <GridItem colSpan={{ base: 5, sm: 5, md: 1, lg: 1 }}>
        <Box>
          <Text {...styles.headerText}>Status</Text>{" "}
          <Select
            {...styles.selector}
            placeholder="All"
            value={searchParams.status}
            onChange={(e) => handleInputChange("status", e.target.value)}>
            <option value="online">Online</option>
            <option value="offline">Offline</option>
          </Select>
        </Box>
      </GridItem>

      <GridItem colSpan={{ base: 6, sm: 6, md: 2, lg: 1 }}>
        <Flex>
          <Button {...styles.searchButton} onClick={handleSearch}>
            Search
          </Button>
          <Spacer />
          <Button {...styles.resetButton} onClick={handleReset}>
            Reset
          </Button>
        </Flex>
      </GridItem>
    </Grid>
  );
};

ControllerSearchFilters.propTypes = {
  searchParams: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
};

export default ControllerSearchFilters;
